import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Layout } from "@/components/site/Layout";
import { ApplyProvider } from "@/context/ApplyContext";
import { captureUtm } from "@/lib/utm";

import { Tracking } from "@/components/site/Tracking";

const LEGAL_SLUGS = ["about-us", "contact-us", "privacy-policy", "terms", "disclaimer", "grievance-redressal", "no-fee-policy", "cookie-policy", "data-deletion", "fair-practices-code", "lending-partners", "partner-terms"];

captureUtm();

const CookieBanner = lazy(() => import("@/components/legal/CookieBanner").then((m) => ({ default: m.CookieBanner })));
const Home = lazy(() => import("@/pages/Home"));
const Loans = lazy(() => import("@/pages/Loans"));
const LoanDetail = lazy(() => import("@/pages/LoanDetail"));
const Calculators = lazy(() => import("@/pages/Calculators"));
const CalculatorPage = lazy(() => import("@/pages/CalculatorPage"));
const BlogList = lazy(() => import("@/pages/BlogList"));
const BlogPost = lazy(() => import("@/pages/BlogPost"));
const Apply = lazy(() => import("@/pages/Apply"));
const Compare = lazy(() => import("@/pages/Compare"));
const LendersCollaboration = lazy(() => import("@/pages/LendersCollaboration"));
const LegalPage = lazy(() => import("@/pages/LegalPage"));
const ComingSoon = lazy(() => import("@/pages/ComingSoon"));
const AdminApp = lazy(() => import("@/admin/AdminApp"));

const Fallback = () => <div className="min-h-screen" />;

const PublicShell = () => (
  <ApplyProvider>
    <Layout>
      <Suspense fallback={<Fallback />}><Outlet /></Suspense>
    </Layout>
    <Suspense fallback={null}><CookieBanner /></Suspense>
    <Tracking />
  </ApplyProvider>
);

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<Fallback />}>
        <Routes>
          <Route path="/admin/*" element={<AdminApp />} />
          <Route element={<PublicShell />}>
            <Route path="/" element={<Home />} />
            {LEGAL_SLUGS.map((s) => <Route key={s} path={`/${s}`} element={<LegalPage slug={s} />} />)}
            <Route path="/loans" element={<Loans />} />
            <Route path="/loans/:slug" element={<LoanDetail />} />
            <Route path="/calculators" element={<Calculators />} />
              <Route path="/calculators/:slug" element={<CalculatorPage />} />
              <Route path="/blog" element={<BlogList />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/apply" element={<Apply />} />
              <Route path="/lenders-collaboration" element={<LendersCollaboration />} />
              <Route path="/compare" element={<Compare />} />
              <Route path="/compare/:product" element={<Compare />} />
            <Route path="*" element={<ComingSoon />} />
          </Route>
        </Routes>
      </Suspense>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
